import Loadable from 'react-loadable';
import Loading from 'components/Loading';
// import {AppSettings} from '../constants';

const ManageRoles = Loadable({
  loader: () => import('./Containers/manage-roles'),
  loading: Loading
});

export default [
  {
    path: '/roles',
    component: ManageRoles,
    private: true,
    menu: {
      name: 'Roles',
      group: 'Admin',
      order: 7,
      subGroup: 'General',
      icons: 'icon-roles-ic'
    }
  }
];



// WEBPACK FOOTER //
// ./src/Manage-Roles/routes.js